import { restartableTask } from 'ember-concurrency';
import StoreService from 'volta/services/-store';
import LabelService from 'volta/services/label-service';
import { defaultErrorHandler } from 'volta/utils/error-utils';

import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

interface IArgs {
  onChange?: (option?: string) => void;
}

export default class UnitMeasuresSelect extends Component<IArgs> {
  @service store!: StoreService;
  @service labelService!: LabelService;

  @tracked custom: string[] = [];
  @tracked existing: string[] = [];

  get options() {
    return this.custom.concat(this.existing);
  }

  @action
  handleDidInsert() {
    this.optionsTask.perform();
  }

  @action
  onCreate(option: string) {
    this.custom = [...this.custom, option];
    this.args.onChange?.(option);
  }

  @action
  search(term: string, { options }: { options: string[] }) {
    const toSearch = term.toLowerCase();
    return options.filter((um: string) => {
      return (
        um.toLowerCase().includes(toSearch) ||
        (this.labelService.unitMeasure(um) || '').toLowerCase().includes(toSearch)
      );
    });
  }

  @action
  showCreateWhen(term: string, options: string[]) {
    const toSearch = term.toLowerCase();
    return !options.some((o) => {
      return (
        o.toLowerCase() === toSearch ||
        (this.labelService.unitMeasure(o) || '').toLowerCase() === toSearch
      );
    });
  }

  optionsTask = restartableTask(async () => {
    try {
      this.existing = await this.store.normalGet('parts/unitMeasures');
      return this.existing;
    } catch (error) {
      defaultErrorHandler(error);
      return;
    }
  });
}
